import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SignalSection } from '../components/SignalSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BibliotecaSection } from '../components/BibliotecaSection';
import { OfferSection } from '../components/OfferSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  return <main className="overflow-hidden bg-background text-foreground min-h-screen font-body" data-id="element-236">
      <HeroSection data-id="element-237" />

      <SignalSection data-id="element-238" />

      <ProtocolSection data-id="element-239" />

      <BenefitsSection data-id="element-240" />
      <PainSection data-id="element-241" />

      <TestimonialsSection data-id="element-242" />

      <DifferenceSection data-id="element-243" />

      

      <ForWhoSection data-id="element-244" />

      <BibliotecaSection data-id="element-245" />

      <OfferSection data-id="element-246" />

      <AboutSection data-id="element-247" />

      <FAQSection data-id="element-248" />

      <FinalCTASection data-id="element-249" />
    </main>;
}